import styled, { css } from "../../styled";
const positionStyles = ({ position, theme, }) => {
    const { space } = theme._ui;
    const toastPosition = {
        "top-left": css `
      top: ${space.s5};
      left: ${space.s5};
    `,
        "top-right": css `
      top: ${space.s5};
      right: ${space.s5};
    `,
        "top-center": css `
      top: ${space.s5};
      left: 50%;
      transform: translateX(-50%);
    `,
        "bottom-left": css `
      bottom: ${space.s5};
      left: ${space.s5};
    `,
        "bottom-right": css `
      bottom: ${space.s5};
      right: ${space.s5};
    `,
        "bottom-center": css `
      bottom: ${space.s5};
      left: 50%;
      transform: translateX(-50%);
    `,
    };
    return toastPosition[position];
};
const mobilePositionStyles = ({ position, theme, }) => {
    const { space } = theme._ui;
    const [vertical, _] = position.split("-");
    const toastPosition = {
        top: css `
      top: ${space.s5};
      left: ${space.s5};
    `,
        bottom: css `
      bottom: ${space.s5};
      left: ${space.s5};
    `,
    };
    return toastPosition[vertical];
};
export const ToastContainer = styled.div `
  pointer-events: none;
  display: flex;
  gap: ${(p) => p.theme._ui.space.s2};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: ${(p) => p.zIndex};
  @media (max-width: ${(p) => p.theme._ui.breakpoints.small}) {
    width: calc(
      calc(100vw - ${(p) => p.theme._ui.space.s5}) -
        ${(p) => p.theme._ui.space.s5}
    );
    ${mobilePositionStyles};
  }
  @media (min-width: ${(p) => p.theme._ui.breakpoints.small}) {
    width: 28rem;
    ${positionStyles};
  }
`;
